import React from 'react';
import { motion } from 'framer-motion';
import './QuoteSection.css';
// Import your couple photo from assets
import coupleImg from '../assets/4.jpeg';

const QuoteSection = () => {
    return (
        <div
            id="quote-section" // Added ID here
            className="quote-container"
        >
            <div className="image-wrapper">
                <img src={coupleImg} alt="Oshini and Dinendra" className="hover-image" />
                <motion.div 
                    className="overlay-content"
                    initial={{ opacity: 0, scale: 0.8, x: "-50%", y: "-30%" }}
                    whileInView={{ opacity: 1, scale: 1, x: "-50%", y: "-50%" }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.7, delay: 0.3 }} /* Reduced duration and delay */
                    style={{ position: 'absolute', top: '50%', left: '50%' }}
                >
                    <p className="quote-text">
                        "I have found the one my soul loves"
                    </p>
                    <p className="quote-source">SONG OF SOLOMON 3:4</p>
                </motion.div>
            </div>
        </div>
    );
};

export default QuoteSection;